import { useQuery } from '@tanstack/react-query';
import { legalService, type LegalLinksResponse } from '@/services/legalService';

const EMPTY: LegalLinksResponse = {
  privacyPolicy: null,
  termsOfService: null,
  hipaaNotice: null,
};

export function useLegalLinks(): { links: LegalLinksResponse; isLoading: boolean } {
  const { data = EMPTY, isLoading } = useQuery({
    queryKey: ['legalLinks'],
    queryFn: legalService.getLinks,
    staleTime: 15 * 60 * 1000, // 15 min — matches server-side cache TTL
    gcTime:    60 * 60 * 1000,
    retry: false,               // missing config is not an error worth retrying
  });

  return { links: data, isLoading };
}
